import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static get targets() {
    return ["results", "winners", "button"];
  }
  toggle() {
    if (!this.hasResultsTarget || !this.hasWinnersTarget) {
      return;
    }
    const winnersHidden = this.winnersTarget.classList.contains("hidden");
    this.winnersTarget.classList.toggle("hidden", !winnersHidden);
    this.resultsTarget.classList.toggle("hidden", winnersHidden);
    if (this.hasButtonTarget) {
      this.buttonTarget.textContent = winnersHidden ? this.buttonTarget.dataset.showResults : this.buttonTarget.dataset.showWinners;
    }
  }
}
